import { hiddenContentStyle } from '../../Styling';
export var getStyles = function (props) {
    return {
        root: props.className,
        screenReaderText: hiddenContentStyle,
    };
};
//# sourceMappingURL=Announced.styles.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/office-ui-fabric-react/lib/components/Announced/Announced.styles.js
// module id = 603
// module chunks = 0